import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import cacheLs from "../cacheLs";

const state = {
  getCurrentMicroApp: cacheLs.get_selected_microapp()
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}